import React, { Component } from "react";
import Header from "./header";
import "./homePage.css";
import Footer from "./footer";
import PresidentItem from "./PresidentItem";

import Img0910 from "./img/past_presidents/2009 - 10 Fonia Wong-min.jpg";
import Img1011 from "./img/past_presidents/2010 - 11 Thomas Chiu-min.jpg";
import Img1112 from "./img/past_presidents/2011 - 12 Daniel Lo-min.jpg";
import Img1213 from "./img/past_presidents/2012 - 13 Olivia Choi-min.jpg";
import Img1314 from "./img/past_presidents/2013 - 14 Andy Lui-min.jpg";
import Img1415 from "./img/past_presidents/2014 - 15 Shirley Tam-min.jpg";
import Img1516 from "./img/past_presidents/2015 - 16 Karen Chan-min.jpg";
import Img1617 from "./img/past_presidents/2016 - 17 Henry Ho-min.jpg";
import Img1718 from "./img/past_presidents/2017 - 18 Kenny Lee-min.jpg";
import Img1819 from "./img/past_presidents/2018 - 19 Elsie Gung_-min.jpg";
import Img1920 from "./img/past_presidents/2019 - 20 Rosenna Mak-min.jpg";
import Img2021 from "./img/past_presidents/2020 - 21 Alex Lau.jpg";
import Img2122 from "./img/past_presidents/2021 - 22 Edmond Chan-min.jpg";
import Img2223 from "./img/past_presidents/2022 - 23 Simone Kong-min.jpg";

import ImgLogo0910 from "./img/past_presidents/logos/2009 - 2010 theme logo.jpg";
import ImgLogo1011 from "./img/past_presidents/logos/2010-2011 theme logo.jpg";
import ImgLogo1112 from "./img/past_presidents/logos/2011 - 2012 theme logo.jpg";
import ImgLogo1213 from "./img/past_presidents/logos/2012 - 2013 theme logo.jpg";
import ImgLogo1314 from "./img/past_presidents/logos/2013 - 2014 theme logo.jpg";
import ImgLogo1415 from "./img/past_presidents/logos/2014 - 2015 theme logo.jpg";
import ImgLogo1516 from "./img/past_presidents/logos/2015 - 2016 theme logo.jpg";
import ImgLogo1617 from "./img/past_presidents/logos/2016 - 2017 theme logo.jpg";
import ImgLogo1718 from "./img/past_presidents/logos/2017 - 2018 theme logo.jpg";
import ImgLogo1819 from "./img/past_presidents/logos/2018 - 2019 theme logo.jpg";
import ImgLogo1920 from "./img/past_presidents/logos/2019 - 2020 theme logo.jpg";
import ImgLogo2021 from "./img/past_presidents/logos/2020 - 2021 theme logo.jpg";
import ImgLogo2122 from "./img/past_presidents/logos/2021 - 2022 theme logo.jpg";
import ImgLogo2223 from "./img/past_presidents/logos/2022 - 2023 theme logo.jpeg";

import ImgTitleDeco from "./img/past_presidents/logo-deco.png";

class PassPresidentsList extends Component {
  presidents = [
    {
      id: "2223",
      name: "Simone Kong",
      year: "2022-23",
      image: Img2223,
      imageLogo: ImgLogo2223,
      imagePos: "50% 10%",
    },
    {
      id: "2122",
      name: "Edmond Chan",
      year: "2021-22",
      image: Img2122,
      imageLogo: ImgLogo2122,
      imagePos: "50% 5%",
      imageScale: "1.6, 1.6",
      imageScalePos: "70% 50%",
    },
    {
      id: "2021",
      name: "Alex Lau",
      year: "2020-21",
      image: Img2021,
      imageLogo: ImgLogo2021,
      imagePos: "50% 0%",
    },
    {
      id: "1920",
      name: "Rosenna Mak",
      year: "2019-20",
      image: Img1920,
      imageLogo: ImgLogo1920,
      imagePos: "50% 0%",
      imageScale: "1.3, 1.3",
      imageScalePos: "70% 0%",
    },
    {
      id: "1819",
      name: "Elsie Gung",
      year: "2018-19",
      image: Img1819,
      imageLogo: ImgLogo1819,
      imagePos: "50% 0%",
    },
    {
      id: "1718",
      name: "Kenny Lee",
      year: "2017-18",
      image: Img1718,
      imageLogo: ImgLogo1718,
      imagePos: "50% 10%",
      imageScale: "1.5, 1.5",
      imageScalePos: "50% 20%",
    },
    {
      id: "1617",
      name: "Henry Ho",
      year: "2016-17",
      image: Img1617,
      imageLogo: ImgLogo1617,
    },
    {
      id: "1516",
      name: "Karen Chan",
      year: "2015-16",
      image: Img1516,
      imageLogo: ImgLogo1516,
      imagePos: "50% 10%",
      imageScale: "1.5, 1.5",
      imageScalePos: "50% 20%",
    },
    {
      id: "1415",
      name: "Shirley Tam",
      year: "2014-15",
      image: Img1415,
      imageLogo: ImgLogo1415,
      imagePos: "50% 0%",
    },
    {
      id: "1314",
      name: "Andy Lui",
      year: "2013-14",
      image: Img1314,
      imageLogo: ImgLogo1314,
      imagePos: "50% 100%",
      imageScale: "1.3, 1.3",
      imageScalePos: "100% 100%",
    },
    {
      id: "1213",
      name: "Olivia Choi",
      year: "2012-13",
      image: Img1213,
      imageLogo: ImgLogo1213,
      imagePos: "50% 0%",
      imageScale: "1.3, 1.3",
      imageScalePos: "50% 30%",
    },
    {
      id: "1112",
      name: "Daniel Lo",
      year: "2011-12",
      image: Img1112,
      imageLogo: ImgLogo1112,
      imagePos: "50% 0%",
      imageScale: "1.3, 1.3",
      imageScalePos: "50% 30%",
    },
    {
      id: "1011",
      name: "Thomas Chiu",
      year: "2010-11",
      image: Img1011,
      imageLogo: ImgLogo1011,
      imagePos: "50% 25%",
      imageScale: "1.3, 1.3",
      imageScalePos: "0% 0%",
    },
    {
      id: "0910",
      name: "Fonia Wong",
      year: "2009-10",
      image: Img0910,
      imageLogo: ImgLogo0910,
      imagePos: "60% 0%",
    },
  ];

  componentWillMount() {}
  render() {
    return (
      <div className="Homepage BoardMemberPage">
        <Header page="aboutus" />

        <div className="homeContentWhite">
          <div className="boardPastPresidents">
            <div className="boardRowPresidentsInner">
              <div className="boardPastPresidentsTitle">
                <img
                  className="boardPastPresidentsTitleDeco"
                  src={ImgTitleDeco}
                  alt=""
                />
                <span>Past Presidents</span>
              </div>
              <div className="boardPastPresidentsGrid">
                <div className="boardPastPresidentsContainer">
                  {this.presidents.map((item) => {
                    return (
                      <div key={item.id} className="boardPastPresident">
                        <PresidentItem data={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default PassPresidentsList;
